module.exports = __webpack_public_path__ + "img/search.de233500.svg";